import { render } from "./LicenseNumberSection.vue?vue&type=template&id=30b3397d"
import script from "./LicenseNumberSection.vue?vue&type=script&lang=js"
export * from "./LicenseNumberSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__